export const GET_ALL_CONFERENCIAS = 'GET_ALL_CONFERENCIAS'
export const GET_CONFERENCIA = 'GET_CONFERENCIA'
